import React from "react"

// TODO: Scope classes to this component
const PlanType = ({ children }) => {
  return (
    <span className="support-article-meta mb-10 p-5">
      <span className="support-article-meta__text">{children}</span>
    </span>
  )
}

export default PlanType
